export const category = [
  {
    id: 1,
    name: "Fashion & Style"
  },
  {
    id: 2,
    name: "Electronics",
  },
  {
    id: 3,
    name: "Home & Kitchen appliances",
  },
  {
    id: 4,
    name: "Modelling",
  },
  {
    id: 5,
    name: "Office Equipment",
  },
  {
    id: 6,
    name: "Groceries",
  },
  {
    id: 7,
    name: "Health & Fitness",
  },
  {
    id: 8,
    name: "Automobiles",
  },
  {
    id: 9,
    name: "Gadgets & Accessories",
  },
  {
    id: 10,
    name: "Music",
  },
  {
    id: 11,
    name: "Comedy",
  },
  {
    id: 12,
    name: "Hair & Beauty",
  },
  {
    id: 13,
    name: "Animals & Pet",
  },
  {
    id: 14,
    name: "Dry Cleaning & Laundry Service",
  },
  {
    id: 15,
    name: "PR & Media",
  },
  {
    id: 16,
    name: "Arts & Books",
  },
  {
    id: 17,
    name: "Entertainment",
  },
  {
    id: 18,
    name: "Gaming",
  },
  {
    id: 19,
    name: "TV, Film & Radio",
  },
  {
    id: 20,
    name: "Charity",
  },
  {
    id: 21,
    name: "Home & Gardens",
  },
  {
    id: 22,
    name: "Jewelry & Accessories",
  },
  {
    id: 23,
    name: "Lifestyle",
  },
  {
    id: 24,
    name: "Politics",
  },
  {
    id: 25,
    name: "Sports",
  },
  {
    id: 26,
    name: "Travel",
  },
  {
    id: 27,
    name: "Weddings",
  },
  {
    id: 28,
    name: "Photography",
  },
]

export const allCategory= category.map(item=>item.name)